<template>
  <div class="certificate-tab-navigation uk-width-1-4@m uk-first-column">
    <nav class="responsive-tab style-3 setting-menu card uk-sticky"
         uk-sticky="top:30 ; offset:100; media:@m ;bottom:true; animation: uk-animation-slide-top">
      <ul id="certificate-tab-nav" class="uk-tab"
          uk-switcher="connect: #user-group-tab ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
        <li :class="{ 'uk-active': activeTab === 0 }">
          <a :aria-expanded="activeTab === 0 ? 'true' : 'false'" href="#" @click="handleTabClick($event, 0)">
            <i class="uil-layer-group"></i>
            {{ $t("certificate.feature") }}
          </a>
        </li>
        <li :class="{ 'uk-active': activeTab === 1 }" class="certificate-type-tab">
          <a :aria-expanded="activeTab === 1 ? 'true' : 'false'" href="#" @click="handleTabClick($event, 1)">
            <i class="uil-tag-alt"></i> {{ $t("general.certificate_type") }}
          </a>
        </li>
      </ul>
    </nav>
    <div class="uk-sticky-placeholder" hidden="" style="height: 158px; margin: 0 0 20px"></div>
  </div>
</template>

<script>
export default {
  name: "CertificateTabNavigation",
  props: {
    activeTab: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleTabClick(event, index) {
      this.$emit('changeTab', index);
    }
  }
};
</script>

<style scoped>
.certificate-type-tab {
  border-top: 2px dashed #e0e0e0 !important;
  position: relative;
}

.certificate-type-tab::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #e0e0e0;
}

.certificate-type-tab a {
  opacity: 0.7;
  font-style: italic;
}

.certificate-type-tab.uk-active a {
  opacity: 1;
  font-style: normal;
}
</style>
